import { render, staticRenderFns } from "./AppTester.vue?vue&type=template&id=5d2cd3ba&scoped=true&"
import script from "./AppTester.vue?vue&type=script&lang=js&"
export * from "./AppTester.vue?vue&type=script&lang=js&"
import style0 from "./AppTester.vue?vue&type=style&index=0&id=5d2cd3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2cd3ba",
  null
  
)

export default component.exports